// Generated by scripts/enrich-thumb-variants.js — do not edit by hand.
// Last run: 2026-06-08T15:51:47.142Z

import {
  INSERT_THUMB_TYPE_CONTOUR_OVAL,
  INSERT_THUMB_TYPE_CONTOUR_TAPER,
  INSERT_THUMB_TYPE_JOPO_INTERCHANGEABLE,
  INSERT_THUMB_TYPE_JOPO_URETHANE_THUMB_SLUG,
  INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
  INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP_NX,
  INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  INSERT_THUMB_TYPE_VISE_IT
} from "./idx_data_thumb_insert_types";

export const idx_data_thumb_outer_variants = [];

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
  category: "switch",
  inner_size: "1 1/4",
  inner_variants: [{"color":"BLACK","upc":"TUR-225-V"},{"color":"BLACK","upc":"TUR-225-41"},{"color":"WHITE","upc":"TUR-225-42"},{"color":"PINK","upc":"TUR-225-43"},{"color":"GREEN","upc":"TUR-225-44"},{"color":"YELLOW","upc":"TUR-225-45"},{"color":"ORANGE","upc":"TUR-225-46"},{"color":"BLUE","upc":"TUR-225-47"},{"color":"RED","upc":"TUR-225-48"},{"color":"PURPLE","upc":"TUR-225-49"}],
  outer_variants: [{"color":"BLACK","upc":"TUR-250.1"},{"color":"BLUE","upc":"TUR-250B.1"},{"color":"GREEN","upc":"TUR-250G.1"},{"color":"ORANGE","upc":"TUR-250O.1"},{"color":"PURPLE","upc":"TUR-250P-1"},{"color":"PINK","upc":"TUR-250PK-1"},{"color":"RED","upc":"TUR-250R-1"},{"color":"YELLOW","upc":"TUR-250Y.1"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
  category: "switch",
  inner_size: "1 3/8",
  inner_variants: [{"color":"DEFAULT","upc":"TUR-238-41"}],
  outer_variants: [{"color":"BLACK","upc":"TUR-250.1"},{"color":"BLUE","upc":"TUR-250B.1"},{"color":"GREEN","upc":"TUR-250G.1"},{"color":"ORANGE","upc":"TUR-250O.1"},{"color":"PURPLE","upc":"TUR-250P-1"},{"color":"PINK","upc":"TUR-250PK-1"},{"color":"RED","upc":"TUR-250R-1"},{"color":"YELLOW","upc":"TUR-250Y.1"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
  category: "switch",
  inner_size: "*",
  inner_variants: [{"color":"GREEN","upc":"TUR-225.4"},{"color":"YELLOW","upc":"TUR-225.5"},{"color":"ORANGE","upc":"TUR-225.6"},{"color":"BLUE","upc":"TUR-225.7"},{"color":"RED","upc":"TUR-225.8"},{"color":"PURPLE","upc":"TUR-225P-1"},{"color":"PINK","upc":"TUR-225PK-1"},{"color":"BLACK","upc":"TUR-225.1"},{"color":"GREEN","upc":"TUR-225.441"},{"color":"YELLOW","upc":"TUR-225.541"},{"color":"ORANGE","upc":"TUR-225.641"},{"color":"BLUE","upc":"TUR-225.741"},{"color":"RED","upc":"TUR-225.841"},{"color":"PURPLE","upc":"TUR-225P-41"},{"color":"PINK","upc":"TUR-225PK-41"}],
  outer_variants: [{"color":"BLACK","upc":"TUR-250.1"},{"color":"BLUE","upc":"TUR-250B.1"},{"color":"GREEN","upc":"TUR-250G.1"},{"color":"ORANGE","upc":"TUR-250O.1"},{"color":"PURPLE","upc":"TUR-250P-1"},{"color":"PINK","upc":"TUR-250PK-1"},{"color":"RED","upc":"TUR-250R-1"},{"color":"YELLOW","upc":"TUR-250Y.1"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP_NX,
  category: "switch",
  inner_size: "1 1/4",
  inner_variants: [{"color":"BLACK","upc":"TUR-225-V"},{"color":"BLACK","upc":"TUR-225-41"},{"color":"WHITE","upc":"TUR-225-42"},{"color":"PINK","upc":"TUR-225-43"},{"color":"GREEN","upc":"TUR-225-44"},{"color":"YELLOW","upc":"TUR-225-45"},{"color":"ORANGE","upc":"TUR-225-46"},{"color":"BLUE","upc":"TUR-225-47"},{"color":"RED","upc":"TUR-225-48"},{"color":"PURPLE","upc":"TUR-225-49"}],
  outer_variants: [{"color":"BLACK","upc":"TUR-250.1"},{"color":"BLUE","upc":"TUR-250B.1"},{"color":"GREEN","upc":"TUR-250G.1"},{"color":"ORANGE","upc":"TUR-250O.1"},{"color":"PURPLE","upc":"TUR-250P-1"},{"color":"PINK","upc":"TUR-250PK-1"},{"color":"RED","upc":"TUR-250R-1"},{"color":"YELLOW","upc":"TUR-250Y.1"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP_NX,
  category: "switch",
  inner_size: "1 3/8",
  inner_variants: [{"color":"DEFAULT","upc":"TUR-238-41"}],
  outer_variants: [{"color":"BLACK","upc":"TUR-250.1"},{"color":"BLUE","upc":"TUR-250B.1"},{"color":"GREEN","upc":"TUR-250G.1"},{"color":"ORANGE","upc":"TUR-250O.1"},{"color":"PURPLE","upc":"TUR-250P-1"},{"color":"PINK","upc":"TUR-250PK-1"},{"color":"RED","upc":"TUR-250R-1"},{"color":"YELLOW","upc":"TUR-250Y.1"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP_NX,
  category: "switch",
  inner_size: "*",
  inner_variants: [{"color":"GREEN","upc":"TUR-225.4"},{"color":"YELLOW","upc":"TUR-225.5"},{"color":"ORANGE","upc":"TUR-225.6"},{"color":"BLUE","upc":"TUR-225.7"},{"color":"RED","upc":"TUR-225.8"},{"color":"PURPLE","upc":"TUR-225P-1"},{"color":"PINK","upc":"TUR-225PK-1"},{"color":"BLACK","upc":"TUR-225.1"},{"color":"GREEN","upc":"TUR-225.441"},{"color":"YELLOW","upc":"TUR-225.541"},{"color":"ORANGE","upc":"TUR-225.641"},{"color":"BLUE","upc":"TUR-225.741"},{"color":"RED","upc":"TUR-225.841"},{"color":"PURPLE","upc":"TUR-225P-41"},{"color":"PINK","upc":"TUR-225PK-41"}],
  outer_variants: [{"color":"BLACK","upc":"TUR-250.1"},{"color":"BLUE","upc":"TUR-250B.1"},{"color":"GREEN","upc":"TUR-250G.1"},{"color":"ORANGE","upc":"TUR-250O.1"},{"color":"PURPLE","upc":"TUR-250P-1"},{"color":"PINK","upc":"TUR-250PK-1"},{"color":"RED","upc":"TUR-250R-1"},{"color":"YELLOW","upc":"TUR-250Y.1"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_JOPO_INTERCHANGEABLE,
  category: "switch",
  inner_size: "1 1/4",
  inner_variants: [{"color":"BLACK","upc":"JOP-TI-001-01"},{"color":"WHITE","upc":"JOP-TI-001-02"},{"color":"YELLOW","upc":"JOP-TI-001-03"},{"color":"ORANGE","upc":"JOP-TI-001-04"},{"color":"GREEN","upc":"JOP-TI-001-05"},{"color":"BLUE","upc":"JOP-TI-001-06"},{"color":"RED","upc":"JOP-TI-001-07"},{"color":"PINK","upc":"JOP-TI-001-08"},{"color":"PURPLE","upc":"JOP-TI-001-09"},{"color":"BLACK","upc":"JOP-TIS-003-01-01"},{"color":"WHITE","upc":"JOP-TIS-003-02-01"},{"color":"WHITE","upc":"JOP-TIS-003-02-02"},{"color":"YELLOW","upc":"JOP-TIS-003-03-01"},{"color":"YELLOW","upc":"JOP-TIS-003-03-03"},{"color":"ORANGE","upc":"JOP-TIS-003-04-01"},{"color":"ORANGE","upc":"JOP-TIS-003-04-04"},{"color":"GREEN","upc":"JOP-TIS-003-05-01"},{"color":"GREEN","upc":"JOP-TIS-003-05-05"},{"color":"BLUE","upc":"JOP-TIS-003-06-01"},{"color":"BLUE","upc":"JOP-TIS-003-06-06"},{"color":"RED","upc":"JOP-TIS-003-07-01"},{"color":"RED","upc":"JOP-TIS-003-07-07"},{"color":"PINK","upc":"JOP-TIS-003-08-01"},{"color":"PINK","upc":"JOP-TIS-003-08-08"},{"color":"PURPLE","upc":"JOP-TIS-003-09-01"},{"color":"PURPLE","upc":"JOP-TIS-003-09-09"},{"color":"DEFAULT","upc":"JOP-TIS-003-09-10"},{"color":"DEFAULT","upc":"JOP-TI-001-10"}],
  outer_variants: [{"color":"BLACK","upc":"JOP-TO-002-01"},{"color":"WHITE","upc":"JOP-TO-002-02"},{"color":"YELLOW","upc":"JOP-TO-002-03"},{"color":"ORANGE","upc":"JOP-TO-002-04"},{"color":"GREEN","upc":"JOP-TO-002-05"},{"color":"BLUE","upc":"JOP-TO-002-06"},{"color":"RED","upc":"JOP-TO-002-07"},{"color":"PINK","upc":"JOP-TO-002-08"},{"color":"PURPLE","upc":"JOP-TO-002-09"},{"color":"DEFAULT","upc":"JOP-TO-002-10"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_JOPO_INTERCHANGEABLE,
  category: "switch",
  inner_size: "1 3/8",
  inner_variants: [{"color":"BLACK","upc":"JOP-TIS-04-01-01"},{"color":"BLACK","upc":"JOP-TIS-04-01-02"},{"color":"BLACK","upc":"JOP-TIS-04-01-03"},{"color":"BLACK","upc":"JOP-TIS-04-01-04"},{"color":"BLACK","upc":"JOP-TIS-04-01-05"},{"color":"BLACK","upc":"JOP-TIS-04-01-06"},{"color":"BLACK","upc":"JOP-TIS-04-01-07"},{"color":"BLACK","upc":"JOP-TIS-04-01-08"},{"color":"BLACK","upc":"JOP-TIS-04-01-09"},{"color":"WHITE","upc":"JOP-TIS-04-02-01"},{"color":"YELLOW","upc":"JOP-TIS-04-03-01"},{"color":"ORANGE","upc":"JOP-TIS-04-04-01"},{"color":"GREEN","upc":"JOP-TIS-04-05-01"},{"color":"BLUE","upc":"JOP-TIS-04-06-01"},{"color":"RED","upc":"JOP-TIS-04-07-01"},{"color":"PINK","upc":"JOP-TIS-04-08-01"},{"color":"PURPLE","upc":"JOP-TIS-04-09-01"}],
  outer_variants: [{"color":"BLACK","upc":"JOP-TO-002-01"},{"color":"WHITE","upc":"JOP-TO-002-02"},{"color":"YELLOW","upc":"JOP-TO-002-03"},{"color":"ORANGE","upc":"JOP-TO-002-04"},{"color":"GREEN","upc":"JOP-TO-002-05"},{"color":"BLUE","upc":"JOP-TO-002-06"},{"color":"RED","upc":"JOP-TO-002-07"},{"color":"PINK","upc":"JOP-TO-002-08"},{"color":"PURPLE","upc":"JOP-TO-002-09"},{"color":"DEFAULT","upc":"JOP-TO-002-10"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_JOPO_URETHANE_THUMB_SLUG,
  category: "simple",
  size: "1 1/8",
  variants: [{"color":"BLACK","upc":"JOP-SLUG01-1"},{"color":"WHITE","upc":"JOP-SLUG01-2"},{"color":"YELLOW","upc":"JOP-SLUG01-3"},{"color":"ORANGE","upc":"JOP-SLUG01-4"},{"color":"GREEN","upc":"JOP-SLUG01-5"},{"color":"BLUE","upc":"JOP-SLUG01-6"},{"color":"RED","upc":"JOP-SLUG01-7"},{"color":"PINK","upc":"JOP-SLUG01-8"},{"color":"PURPLE","upc":"JOP-SLUG01-9"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_JOPO_URETHANE_THUMB_SLUG,
  category: "simple",
  size: "1 1/4",
  variants: [{"color":"BLACK","upc":"JOP-SLUG02-1"},{"color":"WHITE","upc":"JOP-SLUG02-2"},{"color":"YELLOW","upc":"JOP-SLUG02-3"},{"color":"ORANGE","upc":"JOP-SLUG02-4"},{"color":"GREEN","upc":"JOP-SLUG02-5"},{"color":"BLUE","upc":"JOP-SLUG02-6"},{"color":"RED","upc":"JOP-SLUG02-7"},{"color":"PINK","upc":"JOP-SLUG02-8"},{"color":"PURPLE","upc":"JOP-SLUG02-9"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_JOPO_URETHANE_THUMB_SLUG,
  category: "simple",
  size: "1 3/8",
  variants: [{"color":"BLACK","upc":"JOP-SLUG03-1"},{"color":"WHITE","upc":"JOP-SLUG03-2"},{"color":"YELLOW","upc":"JOP-SLUG03-3"},{"color":"ORANGE","upc":"JOP-SLUG03-4"},{"color":"GREEN","upc":"JOP-SLUG03-5"},{"color":"BLUE","upc":"JOP-SLUG03-6"},{"color":"RED","upc":"JOP-SLUG03-7"},{"color":"PINK","upc":"JOP-SLUG03-8"},{"color":"PURPLE","upc":"JOP-SLUG03-9"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_JOPO_URETHANE_THUMB_SLUG,
  category: "simple",
  size: "1 1/2",
  variants: [{"color":"BLACK","upc":"JOP-SLUG04-1"},{"color":"WHITE","upc":"JOP-SLUG04-2"},{"color":"YELLOW","upc":"JOP-SLUG04-3"},{"color":"ORANGE","upc":"JOP-SLUG04-4"},{"color":"GREEN","upc":"JOP-SLUG04-5"},{"color":"BLUE","upc":"JOP-SLUG04-6"},{"color":"RED","upc":"JOP-SLUG04-7"},{"color":"PINK","upc":"JOP-SLUG04-8"},{"color":"PURPLE","upc":"JOP-SLUG04-9"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "51/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-01"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "13/16",
  variants: [{"color":"DEFAULT","upc":"CON-INST-02"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "53/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-03"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "27/32",
  variants: [{"color":"DEFAULT","upc":"CON-INST-04"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "55/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "7/8",
  variants: [{"color":"DEFAULT","upc":"CON-INST-06"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "57/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-07"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "29/32",
  variants: [{"color":"DEFAULT","upc":"CON-INST-08"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "59/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-09"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "15/16",
  variants: [{"color":"DEFAULT","upc":"CON-INST-10"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "61/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-11"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "31/32",
  variants: [{"color":"DEFAULT","upc":"CON-INST-12"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "63/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-13"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "1 1/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-15"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "1 1/32",
  variants: [{"color":"DEFAULT","upc":"CON-INST-16"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "1 3/64",
  variants: [{"color":"DEFAULT","upc":"CON-INST-17"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "1 1/16",
  variants: [{"color":"DEFAULT","upc":"CON-INST-18"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_OVAL,
  category: "simple",
  size: "*",
  variants: [{"color":"DEFAULT","upc":"CON-INST-14"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "51/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-01"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "13/16",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-02"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "53/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-03"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "27/32",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-04"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "55/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "7/8",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-06"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "57/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-07"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "29/32",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-08"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "59/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-09"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "15/16",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-10"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "61/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-11"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "31/32",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-12"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "63/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-13"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "1 1/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-15"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "1 1/32",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-16"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "1 3/64",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-17"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "1 1/16",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-18"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_CONTOUR_TAPER,
  category: "simple",
  size: "*",
  variants: [{"color":"DEFAULT","upc":"CON-INSTR-14"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "51/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-01"},{"color":"WHITE","upc":"TUR-INSTUR-02-01"},{"color":"ORANGE","upc":"TUR-INSTUR-03-01"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "13/16",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-02"},{"color":"WHITE","upc":"TUR-INSTUR-02-02"},{"color":"YELLOW","upc":"TUR-INSTUR-03-015"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "53/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-03"},{"color":"WHITE","upc":"TUR-INSTUR-02-03"},{"color":"YELLOW","upc":"TUR-INSTUR-03-02"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "27/32",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-04"},{"color":"WHITE","upc":"TUR-INSTUR-02-04"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "55/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-05"},{"color":"WHITE","upc":"TUR-INSTUR-02-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "7/8",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-06"},{"color":"WHITE","upc":"TUR-INSTUR-02-06"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "57/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-07"},{"color":"WHITE","upc":"TUR-INSTUR-02-07"},{"color":"YELLOW","upc":"TUR-INSTUR-03-03"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "29/32",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-08"},{"color":"WHITE","upc":"TUR-INSTUR-02-08"},{"color":"ORANGE","upc":"TUR-INSTUR-03-04"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "59/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-09"},{"color":"WHITE","upc":"TUR-INSTUR-02-09"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "15/16",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-10"},{"color":"WHITE","upc":"TUR-INSTUR-02-10"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "61/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-11"},{"color":"WHITE","upc":"TUR-INSTUR-02-11"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "31/32",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-12"},{"color":"WHITE","upc":"TUR-INSTUR-02-12"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "63/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-13"},{"color":"WHITE","upc":"TUR-INSTUR-02-13"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "1 1/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-15"},{"color":"WHITE","upc":"TUR-INSTUR-02-15"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "1 1/32",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-16"},{"color":"WHITE","upc":"TUR-INSTUR-02-16"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "1 3/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-17"},{"color":"WHITE","upc":"TUR-INSTUR-02-17"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "1 1/16",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-18"},{"color":"WHITE","upc":"TUR-INSTUR-02-18"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  category: "simple",
  size: "*",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-14"},{"color":"WHITE","upc":"TUR-INSTUR-02-14"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "51/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-01"},{"color":"BLACK","upc":"TUR-INSTR-02-01"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "13/16",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-02"},{"color":"BLACK","upc":"TUR-INSTR-02-02"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "53/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-03"},{"color":"BLACK","upc":"TUR-INSTR-02-03"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "27/32",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-04"},{"color":"BLACK","upc":"TUR-INSTR-02-04"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "55/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-05"},{"color":"BLACK","upc":"TUR-INSTR-02-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "7/8",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-06"},{"color":"BLACK","upc":"TUR-INSTR-02-06"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "57/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-07"},{"color":"BLACK","upc":"TUR-INSTR-02-07"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "29/32",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-08"},{"color":"BLACK","upc":"TUR-INSTR-02-08"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "59/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-09"},{"color":"BLACK","upc":"TUR-INSTR-02-09"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "15/16",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-10"},{"color":"BLACK","upc":"TUR-INSTR-02-10"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "61/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-11"},{"color":"BLACK","upc":"TUR-INSTR-02-11"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "31/32",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-12"},{"color":"BLACK","upc":"TUR-INSTR-02-12"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "63/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-13"},{"color":"BLACK","upc":"TUR-INSTR-02-13"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "1 1/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-15"},{"color":"BLACK","upc":"TUR-INSTR-02-15"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "1 1/32",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-16"},{"color":"BLACK","upc":"TUR-INSTR-02-16"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "1 3/64",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-17"},{"color":"BLACK","upc":"TUR-INSTR-02-17"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "1 1/16",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-18"},{"color":"BLACK","upc":"TUR-INSTR-02-18"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  category: "simple",
  size: "*",
  variants: [{"color":"DEFAULT","upc":"TUR-INSTR-01-14"},{"color":"BLACK","upc":"TUR-INSTR-02-14"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "51/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-01"},{"color":"WHITE","upc":"TUR-INSTUR-02-01"},{"color":"ORANGE","upc":"TUR-INSTUR-03-01"},{"color":"DEFAULT","upc":"TUR-INSTR-01-01"},{"color":"BLACK","upc":"TUR-INSTR-02-01"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "13/16",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-02"},{"color":"WHITE","upc":"TUR-INSTUR-02-02"},{"color":"YELLOW","upc":"TUR-INSTUR-03-015"},{"color":"DEFAULT","upc":"TUR-INSTR-01-02"},{"color":"BLACK","upc":"TUR-INSTR-02-02"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "53/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-03"},{"color":"WHITE","upc":"TUR-INSTUR-02-03"},{"color":"YELLOW","upc":"TUR-INSTUR-03-02"},{"color":"DEFAULT","upc":"TUR-INSTR-01-03"},{"color":"BLACK","upc":"TUR-INSTR-02-03"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "27/32",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-04"},{"color":"WHITE","upc":"TUR-INSTUR-02-04"},{"color":"DEFAULT","upc":"TUR-INSTR-01-04"},{"color":"BLACK","upc":"TUR-INSTR-02-04"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "55/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-05"},{"color":"WHITE","upc":"TUR-INSTUR-02-05"},{"color":"DEFAULT","upc":"TUR-INSTR-01-05"},{"color":"BLACK","upc":"TUR-INSTR-02-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "7/8",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-06"},{"color":"WHITE","upc":"TUR-INSTUR-02-06"},{"color":"DEFAULT","upc":"TUR-INSTR-01-06"},{"color":"BLACK","upc":"TUR-INSTR-02-06"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "57/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-07"},{"color":"WHITE","upc":"TUR-INSTUR-02-07"},{"color":"YELLOW","upc":"TUR-INSTUR-03-03"},{"color":"DEFAULT","upc":"TUR-INSTR-01-07"},{"color":"BLACK","upc":"TUR-INSTR-02-07"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "29/32",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-08"},{"color":"WHITE","upc":"TUR-INSTUR-02-08"},{"color":"ORANGE","upc":"TUR-INSTUR-03-04"},{"color":"DEFAULT","upc":"TUR-INSTR-01-08"},{"color":"BLACK","upc":"TUR-INSTR-02-08"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "59/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-09"},{"color":"WHITE","upc":"TUR-INSTUR-02-09"},{"color":"DEFAULT","upc":"TUR-INSTR-01-09"},{"color":"BLACK","upc":"TUR-INSTR-02-09"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "15/16",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-10"},{"color":"WHITE","upc":"TUR-INSTUR-02-10"},{"color":"DEFAULT","upc":"TUR-INSTR-01-10"},{"color":"BLACK","upc":"TUR-INSTR-02-10"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "61/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-11"},{"color":"WHITE","upc":"TUR-INSTUR-02-11"},{"color":"DEFAULT","upc":"TUR-INSTR-01-11"},{"color":"BLACK","upc":"TUR-INSTR-02-11"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "31/32",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-12"},{"color":"WHITE","upc":"TUR-INSTUR-02-12"},{"color":"DEFAULT","upc":"TUR-INSTR-01-12"},{"color":"BLACK","upc":"TUR-INSTR-02-12"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "63/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-13"},{"color":"WHITE","upc":"TUR-INSTUR-02-13"},{"color":"DEFAULT","upc":"TUR-INSTR-01-13"},{"color":"BLACK","upc":"TUR-INSTR-02-13"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "1 1/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-15"},{"color":"WHITE","upc":"TUR-INSTUR-02-15"},{"color":"DEFAULT","upc":"TUR-INSTR-01-15"},{"color":"BLACK","upc":"TUR-INSTR-02-15"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "1 1/32",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-16"},{"color":"WHITE","upc":"TUR-INSTUR-02-16"},{"color":"DEFAULT","upc":"TUR-INSTR-01-16"},{"color":"BLACK","upc":"TUR-INSTR-02-16"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "1 3/64",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-17"},{"color":"WHITE","upc":"TUR-INSTUR-02-17"},{"color":"DEFAULT","upc":"TUR-INSTR-01-17"},{"color":"BLACK","upc":"TUR-INSTR-02-17"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "1 1/16",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-18"},{"color":"WHITE","upc":"TUR-INSTUR-02-18"},{"color":"DEFAULT","upc":"TUR-INSTR-01-18"},{"color":"BLACK","upc":"TUR-INSTR-02-18"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  category: "simple",
  size: "*",
  variants: [{"color":"BLACK","upc":"TUR-INSTUR-01-14"},{"color":"WHITE","upc":"TUR-INSTUR-02-14"},{"color":"DEFAULT","upc":"TUR-INSTR-01-14"},{"color":"BLACK","upc":"TUR-INSTR-02-14"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  category: "simple",
  size: "1 1/4",
  variants: [{"color":"BLACK","upc":"TUR-225-41"},{"color":"WHITE","upc":"TUR-225-42"},{"color":"PINK","upc":"TUR-225-43"},{"color":"GREEN","upc":"TUR-225-44"},{"color":"YELLOW","upc":"TUR-225-45"},{"color":"ORANGE","upc":"TUR-225-46"},{"color":"BLUE","upc":"TUR-225-47"},{"color":"RED","upc":"TUR-225-48"},{"color":"PURPLE","upc":"TUR-225-49"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  category: "simple",
  size: "1 3/8",
  variants: [{"color":"DEFAULT","upc":"TUR-238-41"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  category: "simple",
  size: "*",
  variants: [{"color":"GREEN","upc":"TUR-225.441"},{"color":"YELLOW","upc":"TUR-225.541"},{"color":"ORANGE","upc":"TUR-225.641"},{"color":"BLUE","upc":"TUR-225.741"},{"color":"RED","upc":"TUR-225.841"},{"color":"PURPLE","upc":"TUR-225P-41"},{"color":"PINK","upc":"TUR-225PK-41"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  category: "simple",
  size: "1 1/8",
  variants: [{"color":"BLACK","upc":"ULT-SLUG-01-01"},{"color":"BLUE","upc":"ULT-SLUG-01-02"},{"color":"DEFAULT","upc":"ULT-SLUG-01-03"},{"color":"RED","upc":"ULT-SLUG-01-04"},{"color":"YELLOW","upc":"ULT-SLUG-01-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  category: "simple",
  size: "1 1/4",
  variants: [{"color":"BLACK","upc":"ULT-SLUG-02-01"},{"color":"BLUE","upc":"ULT-SLUG-02-02"},{"color":"DEFAULT","upc":"ULT-SLUG-02-03"},{"color":"RED","upc":"ULT-SLUG-02-04"},{"color":"YELLOW","upc":"ULT-SLUG-02-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  category: "simple",
  size: "1 3/8",
  variants: [{"color":"BLACK","upc":"ULT-SLUG-03-01"},{"color":"BLUE","upc":"ULT-SLUG-03-02"},{"color":"DEFAULT","upc":"ULT-SLUG-03-03"},{"color":"RED","upc":"ULT-SLUG-03-04"},{"color":"YELLOW","upc":"ULT-SLUG-03-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  category: "simple",
  size: "1 1/2",
  variants: [{"color":"BLACK","upc":"ULT-SLUG-04-01"},{"color":"BLUE","upc":"ULT-SLUG-04-02"},{"color":"DEFAULT","upc":"ULT-SLUG-04-03"},{"color":"RED","upc":"ULT-SLUG-04-04"},{"color":"YELLOW","upc":"ULT-SLUG-04-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  category: "simple",
  size: "1 1/8",
  variants: [{"color":"BLACK","upc":"ULT-SLUG-01-01"},{"color":"BLUE","upc":"ULT-SLUG-01-02"},{"color":"DEFAULT","upc":"ULT-SLUG-01-03"},{"color":"RED","upc":"ULT-SLUG-01-04"},{"color":"YELLOW","upc":"ULT-SLUG-01-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  category: "simple",
  size: "1 1/4",
  variants: [{"color":"BLACK","upc":"ULT-SLUG-02-01"},{"color":"BLUE","upc":"ULT-SLUG-02-02"},{"color":"DEFAULT","upc":"ULT-SLUG-02-03"},{"color":"RED","upc":"ULT-SLUG-02-04"},{"color":"YELLOW","upc":"ULT-SLUG-02-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  category: "simple",
  size: "1 3/8",
  variants: [{"color":"BLACK","upc":"ULT-SLUG-03-01"},{"color":"BLUE","upc":"ULT-SLUG-03-02"},{"color":"DEFAULT","upc":"ULT-SLUG-03-03"},{"color":"RED","upc":"ULT-SLUG-03-04"},{"color":"YELLOW","upc":"ULT-SLUG-03-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  category: "simple",
  size: "1 1/2",
  variants: [{"color":"BLACK","upc":"ULT-SLUG-04-01"},{"color":"BLUE","upc":"ULT-SLUG-04-02"},{"color":"DEFAULT","upc":"ULT-SLUG-04-03"},{"color":"RED","upc":"ULT-SLUG-04-04"},{"color":"YELLOW","upc":"ULT-SLUG-04-05"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_VISE_IT,
  category: "simple",
  size: "1 1/8",
  variants: [{"color":"BLACK","upc":"VIS-IT7"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_VISE_IT,
  category: "simple",
  size: "1 1/4",
  variants: [{"color":"BLACK","upc":"VIS-IT8"},{"color":"YELLOW","upc":"VIS-IT81"},{"color":"WHITE","upc":"VIS-IT86"},{"color":"NEON","upc":"VIS-IT88"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_VISE_IT,
  category: "simple",
  size: "1 3/8",
  variants: [{"color":"BLACK","upc":"VIS-IT9"},{"color":"YELLOW","upc":"VIS-IT91"},{"color":"GREEN","upc":"VIS-IT92"},{"color":"ORANGE","upc":"VIS-IT93"}],
});

idx_data_thumb_outer_variants.push({
  type_id: INSERT_THUMB_TYPE_VISE_IT,
  category: "simple",
  size: "1 1/2",
  variants: [{"color":"BLACK","upc":"VIS-IT9.1"}],
});
